import React, { useContext } from "react";
import { NavContext } from '../../App';
import Tabs from '../TabsContainer/Tabs';

export default function MainContainer() {
  const context = useContext(NavContext);
  const tabs = context?.tabs;
  const setTabs = context?.setTabs;

  return (
    <Tabs 
      tabs={tabs} 
      selectedTab={context.activeTab} 
      setTabs={setTabs}
    />
  );
}